import type { AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, Component, HostListener, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoTextService } from '../../services/infotext.service';
import { InfotextItemComponent } from './infotext-item/infotext-item.component';

@Component({
  selector: 'ui-infotext-sidebar',
  standalone: true,
  templateUrl: './infotext-sidebar.component.html',
  // Angular's change-detection-eager migration made the previously implicit default explicit;
  // this was never annotated `Default`. The template is `| async` plus `<ng-content />` and the
  // only other trigger is a @HostListener, so it looks OnPush-safe — but proving that is a
  // behaviour change needing browser verification, which does not belong in a version hop.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, InfotextItemComponent],
})
export class InfotextSidebarComponent implements AfterViewInit, OnDestroy {
  private infotextService = inject(InfoTextService);
  @ViewChild('infotextContainer', { static: false }) infotextContainer!: ElementRef<HTMLElement>;
  @ViewChild('generalInfotextContainer', { static: false })
  generalInfotextsContainer!: ElementRef<HTMLElement>;

  conceptualInfoText$ = this.infotextService.infotext$;

  ngAfterViewInit() {
    this.infotextService.setContainer(this.infotextContainer, this.generalInfotextsContainer);
  }

  ngOnDestroy() {
    this.infotextService.clearContainer();
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    if (!this.infotextService.hasActiveInfotext) return;

    const target = event.target as HTMLElement | null;
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (
      target?.closest('ui-infotext-item') ||
      target?.closest('ui-infotext-trigger') ||
      target?.closest('[uiInfotextAnchor]') ||
      (target && overlayContainer?.contains(target))
    ) {
      return;
    }

    this.infotextService.showConceptual(null);
  }
}
